<template>
  <section v-for="(item, index) in cardData" :key="index" class="my-5">
    <div ref="cards" :class="`bg-white rounded-t-md shadow-sm overflow-hidden`">
      <div :class="`grid grid-cols-12 items-center`">
        <div class="col-span-3 relative">
          <img
            v-if="grow[index]?.value === false"
            src="@/assets/images/crawler-thumb.svg"
            alt="thumb-video"
            class="w-full h-32 object-cover object-center transition-all"
          />
        </div>
        <div v-if="grow[index]?.value === true" class="col-span-12">
          <VideoComponent
            :data="{ url: item.url }"
            :idVideo="item.uuid"
            :startTime="time"
            :attention="false"
            ref="videoComponent"
          />
        </div>
        <div
          v-if="grow[index]?.value === false"
          class="col-span-9 flex flex-col gap-3 p-5"
        >
          <h6 class="font-bold">{{ item.nameVideo }}</h6>
          <p class="text-sm">
            <strong>{{ $t("crawler.words.course") }}</strong>
            {{ item.nameCourse }}
          </p>
          <div class="flex gap-3 items-center">
            <p class="text-sm">
              <strong>{{ $t("crawler.words.chapter") }}</strong>
              {{ item.nameChapter }}
            </p>
            <p class="text-sm">
              <strong>{{ $t("crawler.words.duration") }}</strong>
              {{ generics.getDurationTime(item.duration) }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <Accordion
      class="accordion-material-custom"
      :lazy="true"
      @tabOpen="open($event, index)"
      @tabClose="close($event, index)"
    >
      <AccordionTab :header="$t('crawler.indexWords')">
        <div v-for="(info, i) in item.transcripts" :key="i">
          <div
            class="border-b flex items-center w-full gap-3 hover:bg-h-secondary-50 transition-all cursor-pointer"
            @click.prevent="onClickDuration(info.startTime, index)"
          >
            <div class="flex items-center gap-1 font-bold p-3 text-black">
              <p>
                {{ duration(info.startTime) }}
              </p>
              <p>-</p>
              <p>{{ duration(info.endTime) }}</p>
            </div>
            <div class="w-full py-5 text-black">
              <p>{{ info.transcript }}</p>
            </div>
          </div>
        </div>
      </AccordionTab>
    </Accordion>
  </section>
</template>

<script lang="ts">
import { GenericsUtils } from "@/utils/generics.util";
import moment from "moment";
import { defineComponent, PropType } from "vue";

export default defineComponent({
  name: "cardCrawler",
  computed: {
    generics(): GenericsUtils {
      return new GenericsUtils();
    },
  },
  props: {
    data: {
      type: Array as PropType<any>,
    },
  },
  data() {
    return {
      grow: [] as any,
      cardData: [] as any,
      time: 0 as number,
    };
  },
  mounted() {
    if (this.data) {
      this.cardData = this.data;
      this.cardData?.forEach(() => {
        this.grow.push({ value: false });
      });
    }
  },
  methods: {
    open(event, index): void {
      event.index = index;
      this.grow[index].value = true;
    },
    close(event, index): void {
      event.index = index;
      this.grow[index].value = false;
    },
    onClickDuration(value: any, cardIndex: any): void {
      this.time = value;
      this.scrollToActualItem(cardIndex);
    },
    duration(sec: number): any {
      return moment.utc(sec * 1000).format("mm:ss");
    },
    scrollToActualItem(index: number): void {
      setTimeout(() => {
        (this.$refs.cards as any)[index]?.scrollIntoView({
          behavior: "smooth",
          block: "nearest",
          inline: "start",
        });
      }, 200);
    },
  },
});
</script>
